import { render, staticRenderFns } from "./CmpXFormRoutes.vue?vue&type=template&id=185c6c0a&scoped=true&"
import script from "./CmpXFormRoutes.vue?vue&type=script&lang=js&"
export * from "./CmpXFormRoutes.vue?vue&type=script&lang=js&"
import style0 from "./CmpXFormRoutes.vue?vue&type=style&index=0&id=185c6c0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c6c0a",
  null
  
)

export default component.exports